module.exports = __webpack_public_path__ + "static/media/flow-diagram-processes-planning.2a87414b.jpg";